import { render, staticRenderFns } from "./StatusesBox.vue?vue&type=template&id=7a42ee70&"
import script from "./StatusesBox.vue?vue&type=script&lang=js&"
export * from "./StatusesBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports